import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { ROUTE_GET_POINTS } from "../constants";
import { abfSerializeQueryArgs, rubyPublicBaseQuery, unauthenticatedSerializeQueryArgs } from "./util";
import {
    LoopscalePointsAction,
    PointMultiplier,
    PointsReward,
    RewardsFilter,
    RewardsWithMultipliersResponse
} from "../types";

const POINTS_DATA_TAG = "Points";

type RawRewardsWithMultipliersResponse = {
    rewards: PointsReward[];
    multipliers: Array<Omit<PointMultiplier, "reward"> & { reward: number }>;
};

export const pointsPublicApi = createApi({
    reducerPath: "pointsPublicApi",
    tagTypes: [POINTS_DATA_TAG],
    baseQuery: rubyPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    endpoints: (builder) => ({
        rewardsWithMultipliers: builder.query<RewardsWithMultipliersResponse, RewardsFilter>({
            serializeQueryArgs: unauthenticatedSerializeQueryArgs,
            providesTags: [POINTS_DATA_TAG],
            query(body) {
                return {
                    url: ROUTE_GET_POINTS,
                    method: "POST",
                    body
                };
            },
            transformResponse: (response: RawRewardsWithMultipliersResponse) => ({
                rewards: response.rewards ?? [],
                multipliers: (response.multipliers ?? []).map((item) => ({
                    ...item,
                    reward: item.reward as LoopscalePointsAction
                }))
            })
        })
    })
});

export const { useRewardsWithMultipliersQuery } = pointsPublicApi;

export function usePointsPublicApi() {
    const dispatch = useDispatch();

    return {
        resetLoanMultipliers: () => dispatch(pointsPublicApi.util.invalidateTags([POINTS_DATA_TAG]))
    };
}
